// src/pages/AddPeoplePage.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { InviteNewUsers } from '@components/AdminConsole/InviteNewUsers';

export const AddPeoplePage: React.FC = () =>
{
  const navigate = useNavigate();

  useEffect(() =>
  {
    document.title = 'Add Users';
  }, []);

  return <InviteNewUsers asPage onCancel={() => navigate(-1)} onSuccess={() => navigate(-1)} />;
};

export default AddPeoplePage;
